import { configureDatabase } from "../../main/data/data";
import { initHTML } from "./initHTML";
import { initalizeControlPanel } from "./initalizeControlPanel";
import { isAuth } from "./isAuth";
import { loginUI } from "./loginUI";
import { refreshActiveItem } from "./refreshActiveItem";
import { removeActiveItem } from "./removeActiveItem";
import { submitEditURL } from "./submitEditURL";
import { updateEditInput } from "./updateEditInput";
window.addEventListener("load", () => {
    const body = document.querySelector("body");
    initHTML();
    configureDatabase();
    isAuth(initalizeControlPanel, loginUI);
    body.addEventListener("click", (e) => {
        removeActiveItem(e);
        refreshActiveItem(e);
    });
    body.addEventListener("change", (e) => {
        updateEditInput(e);
    });
    body.addEventListener("submit", (e) => {
        submitEditURL(e);
    });
});
